import React from 'react';
import styles from './styles.module.css';
import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import dayjs from 'dayjs';
import { formatDate, formatNumber, getMeasureValue, historyGroups, sortByDateDesc } from './bodyMeasurementsMath';

/**
 * Histórico em tabela: uma linha por medida (só as que têm valor em alguma
 * avaliação, agrupadas por região, mais os indicadores calculados) e uma
 * coluna por avaliação, da mais recente para a mais antiga. Medida ausente
 * aparece como "—", nunca como zero. A primeira coluna fica fixa na rolagem
 * horizontal. `subject` ({ variant, birthday }) permite a gordura pelas dobras.
 */
const BodyMeasurementsTable = ({ history, subject, enabled, onEdit }) => {
  const columns = sortByDateDesc(history);
  const groups = historyGroups(history, columns, subject);

  // Duas avaliações no mesmo dia: a hora diferencia as colunas
  const dayCount = {};
  columns.forEach((assessment) => {
    const day = formatDate(assessment.measuredAt);
    dayCount[day] = (dayCount[day] || 0) + 1;
  });

  const cell = (assessment, measure) => {
    const text = formatNumber(getMeasureValue(history, assessment, measure.key, subject), measure.decimals);
    return text === null ? <span className={styles.missing}>—</span> : text;
  };

  return (
    <div className={styles.tableScroll}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.stickyCol}>Medida</th>
            {columns.map((assessment) => {
              const day = formatDate(assessment.measuredAt);
              return (
                <th key={assessment.id}>
                  <div className={styles.colHead}>
                    <span>
                      {day}
                      {dayCount[day] > 1 && <span className={styles.colTime}>{dayjs(assessment.measuredAt).format('HH:mm')}</span>}
                    </span>
                    {enabled && (
                      <IconButton
                        size="small"
                        className={styles.editButton}
                        aria-label="Editar avaliação"
                        onClick={() => onEdit(assessment)}
                      >
                        <EditOutlinedIcon fontSize="inherit" />
                      </IconButton>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <React.Fragment key={group.key}>
              <tr className={styles.groupRow}>
                <td colSpan={columns.length + 1}>{group.label}</td>
              </tr>
              {group.measures.map((measure) => (
                <tr key={measure.key}>
                  <td className={styles.stickyCol}>
                    {measure.label}
                    <span className={styles.unit}>{measure.unit}</span>
                  </td>
                  {columns.map((assessment, index) => (
                    <td key={assessment.id} className={index === 0 ? styles.currentCell : ''}>
                      {cell(assessment, measure)}
                    </td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BodyMeasurementsTable;
